import { render, staticRenderFns } from "./carmanage.vue?vue&type=template&id=2a2dbc22&"
import script from "./carmanage.vue?vue&type=script&lang=js&"
export * from "./carmanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports